import React from "react";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";


const LoadingIndicator = ({ message = "loading" }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "center",
        }}
    >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        <div>{message}</div>
    </div>
);

export default LoadingIndicator;
